let course_listings = (function( $ ) {

	let initialize = function() {
		$( 'a.open-modal' ).on( 'click', handle_modal_click );
		toggle_icon();
		setup_letter_links();
	};

	let handle_modal_click = function() {
		let event_id = $( this ).attr( 'id' );
		$( '#field_event_id' ).val( event_id );

		let course_name;
		if ( window.location.pathname === '/events/' ) {
			course_name = $( this ).closest( '.card-left.private' ).find( '.event-title' ).text().trim();
		} else {
			course_name = $( this ).closest( '.panel-wrap' ).find( '.course-name' ).text().trim();
		}

		update_request_title( course_name );
	};

	let update_request_title = function( course_name ) {
		$( '#request_for_title' ).text( course_name );
	};

	let setup_letter_links = function() {
		$( '.letter-link' ).click( function( e ) {
			e.preventDefault();
			$( '.letter-link' ).removeClass( 'active' );
			let target = $( this ).attr( 'href' );
			let scrollPosition = $( target ).offset().top - 150;
			$( 'html, body' ).animate( {
				scrollTop: scrollPosition
			}, 1000 );
			$( this ).addClass( 'active' );
		} );
	};

	let toggle_icon = function() {
		$('.course-info').on('click', function() {
			$(this).find('.info-icon').toggleClass('open');
		});
	}

	$( document ).ready( initialize );

	return {};

})( jQuery );

module.exports = course_listings;